import { api } from "@/api";
import { AxiosResponse } from "axios";
class API {
  static getMiniExtract(): Promise<AxiosResponse> {
    return api.get("/exclusive-club/summary");
  }
  static getAbout(): Promise<AxiosResponse> {
    return api.get("/exclusive-club/about");
  }
  static getSurveyMonkey(payload: any): Promise<AxiosResponse> {
    return api.get("/exclusive-club/surveys", { params: payload.params });
  }
  static getAvailableItems(payload: any): Promise<AxiosResponse> {
    return api.get("/products", { params: payload });
  }
  static getRedeemedItems(payload: any): Promise<AxiosResponse> {
    return api.get("/products/redeemeds", { params: payload });
  }
  static getProduct(payload: string): Promise<AxiosResponse> {
    return api.get(`/products/${payload}`);
  }
  static patchRedeemProduct(payload: string): Promise<AxiosResponse> {
    return api.patch(`/products/redemptions/request/${payload}`);
  }
  static postProduct(payload: FormData): Promise<AxiosResponse> {
    return api.post("/products", payload);
  }
  static putProduct(payload: any): Promise<AxiosResponse> {
    return api.put(`/products/${payload.id}`, payload.params);
  }
}

export default API;
